import { CR_SUBMISSION } from '../../../constants';

export type ShowStarRatingErrorBlockParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const showStarRatingErrorBlock = ({ rootElement }: ShowStarRatingErrorBlockParams) => {
    const starRatingErrorBlock = rootElement.querySelector<HTMLDivElement>(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_SELECTOR);
    if (starRatingErrorBlock === null) return;
    starRatingErrorBlock.classList.remove(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
};
